import axios from 'axios'

export default {
    namespaced: true,
    state: {
        states: [],
        status_array: [],
        job_status_array: [],
        roles: [],
        counties: [],
        sizes: [],
        options: [],
		preffered_time: [],
		preffered_contact: [],
        how_did_hear: [],
        leads: [],
        estimators: [],
        schedules_array: [],
        confirmations_array: [],
        assign_array: [],
        users: [],
        job_types: [],
        shapes: [],
        liner_color: []
    },
    getters: {
        states (state) {
            return state.states
        },
        statusArray (state) {
            return state.status_array
        },
        jobStatusArray (state) {
            return state.job_status_array
        },
        roles (state) {
            return state.roles
        },
        counties (state) {
            return state.counties
        },
        sizes (state) {
            return state.sizes
        },
        shapes (state) {
            return state.shapes
        },
        options (state) {
            return state.options
        },
        filteredOptions (state) {
            return state.options.filter(option => {
                return option.required != "Yes"
            })
        },
        requiredOptions (state) {
            return state.options.filter(option => {
                return option.required == "Yes"
            })
        },
        requiredTotal (state) {
            var sum = 0
            state.options.forEach(option => {
                if(option.required == 'Yes')
                    sum += parseFloat(option.price)
            });
            return sum
        },
		preffered_time (state) {
			return state.preffered_time
		},
		preffered_contact (state) {
			return state.preffered_contact
		},
		how_did_hear (state) {
			return state.how_did_hear
        },
        leads (state) {
            return state.leads
        },
        estimators (state) {
            return state.estimators
        },
        schedulesArray (state) {
            return state.schedules_array
        },
        confirmationsArray (state) {
            return state.confirmations_array
        },
        assignArray (state) {
            return state.assign_array
        },
        users (state) {
            return state.users
        },
        job_types (state) {
            return state.job_types
        },
        liner_color (state) {
            return state.liner_color
        },
    },
    mutations: {
        SET_STATES(state, payload) {
            state.states = payload
        },
        SET_STATUS_ARR(state, payload) {
            return state.status_array = payload
        },
        SET_JOB_STATUS_ARR(state, payload) {
            return state.job_status_array = payload
        },
        SET_ROLES(state, payload) {
            return state.roles = payload
        },
        SET_COUNTIES(state, payload) {
            state.counties = payload
        },
        SET_SIZES(state, payload) {
            state.sizes = payload
        },
        SET_SHAPES(state, payload) {
            state.shapes = payload
        },
        SET_OPTIONS(state, payload) {
            state.options = payload
        },
        SET_PREFFRED(state, payload) {
            return state.preffered_time = payload
		},
        SET_PREFFRED_CONTACT(state, payload) {
            return state.preffered_contact = payload
		},
        SET_HOW(state, payload) {
            return state.how_did_hear = payload
        },
        SET_LEADS(state, payload) {
            return state.leads = payload
        },
        SET_ESTIMATORS(state, payload) {
            return state.estimators = payload
        },
        SET_SCHEDULES_ARR(state, payload) {
            return state.schedules_array = payload
        },
        SET_CONFIRMATION_ARR(state, payload) {
            return state.confirmations_array = payload
        },
        SET_ASSIGN_ARR(state, payload) {
            return state.assign_array = payload
        },
        SET_USERS(state, payload) {
            return state.users = payload
        },
        SET_JOB_TYPES(state, payload) {
            return state.job_types = payload
        },
        SET_JOB_TYPE(state, payload) {
            return state.job_types.push(payload)
        },
        SET_LINER_COLOR(state, payload) {
            return state.liner_color = payload
        },
    },
    actions: {
        async getData({ commit }) {
            let response = await axios.post('crm/data')
            commit('SET_STATES', response.data.data.states)     
            commit('SET_STATUS_ARR', response.data.data.status_array)
            commit('SET_JOB_STATUS_ARR', response.data.data.job_status_array)
            commit('SET_ROLES', response.data.data.roles)
            commit('SET_NEW_COUNT', response.data.data.new_count)
            commit('SET_ALL_COUNT', response.data.data.total_count)
            commit('SET_COUNTIES', response.data.data.counties)
            commit('SET_SIZES', response.data.data.sizes)
            commit('SET_SHAPES', response.data.data.shapes)
            commit('SET_OPTIONS', response.data.data.options)
            commit('SET_PREFFRED', response.data.data.preffered_time)
            commit('SET_PREFFRED_CONTACT', response.data.data.preffered_contact)
            commit('SET_HOW', response.data.data.how_did_hear)
            commit('SET_ESTIMATORS', response.data.data.estimators)        
            commit('SET_SCHEDULES_ARR', response.data.data.schedules_array)
            commit('SET_CONFIRMATION_ARR', response.data.data.confirmations_array)
            commit('SET_ASSIGN_ARR', response.data.data.assign_array)
            commit('SET_USERS', response.data.data.users)
            commit('SET_JOB_TYPES', response.data.data.job_types)
            commit('SET_LINER_COLOR', response.data.data.liner_color)
        },
        async addComment(_, data) {
            let response = await axios.post('crm/lead/comment', data)        
            return response.data
        },
        async addJobComment(_, data) {
            let response = await axios.post('crm/job/comment', data)        
            return response.data
        },
    }
}